import React, { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { debounce } from 'lodash';

import OrdersFilters from '../components/orders-filters/orders-filters';
import {
  fetchOrdersRoles,
  fetchOrdersStatuses,
  fetchUserOrders,
  setFiltersQuery,
  setPage,
  setPeriodData,
  setSelectFilter,
} from '../store/actions/orders';
import { RootState } from '../types';

const OrdersFiltersContainer: FC = () => {
  const dispatch = useDispatch();
  const orders = useSelector((state: RootState) => state.orders);
  const [selectedRole, setSelectedRole] = useState<string>(
    orders.data.filters.role
  );

  useEffect(() => {
    dispatch(fetchOrdersRoles());
    dispatch(fetchOrdersStatuses());
  }, []);

  useEffect(
    debounce(() => {
      dispatch(fetchUserOrders());
    }, 300),
    [
      orders.data.filters.search,
      orders.data.filters.role,
      orders.data.filters.orderStatuses,
      orders.data.filters.periodData.from,
      orders.data.filters.periodData.to,
    ]
  );

  const selectRoles = orders.data.roles.map((item) => ({
    value: item.name,
    label: item.label,
  }));

  const onSelect = (
    type: 'role' | 'orderStatuses',
    value: string | string[]
  ) => {
    dispatch(setPage(0));
    dispatch(setSelectFilter({ type, value }));
    type === 'role' && setSelectedRole(value as string);
  };

  return (
    <OrdersFilters
      period={{
        from: orders.data.filters.periodData.from,
        to: orders.data.filters.periodData.to,
      }}
      onPeriodChange={(range) => {
        dispatch(setPage(0));
        dispatch(
          setPeriodData({
            from: range.from,
            to: range.to,
          })
        );
      }}
      selectedRole={selectedRole}
      selectedStatus={orders.data.filters.orderStatuses}
      onRoleSelect={(role) => onSelect('role', role)}
      onStatusSelect={(status) => onSelect('orderStatuses', status)}
      statuses={orders.data.statuses.map((item) => ({
        label: item.label,
        value: item.name,
      }))}
      roles={selectRoles}
      searchQuery={orders.data.filters.search}
      onSearchQueryChange={(query) => {
        setPage(0);
        dispatch(setFiltersQuery(query));
      }}
    />
  );
};

export default OrdersFiltersContainer;
